/**
 * "n selected · Clear" chip — appears next to the date-range controls
 * (dashboard toolbar + Analytics tab) whenever a cross-widget campaign
 * selection is active. Reads the shared marketingStore selection, so it
 * needs no props and stays in sync across surfaces.
 */

import { X } from 'lucide-react'
import { useMarketingStore } from '@/stores/marketingStore'

export function CampaignSelectionChip() {
  const count = useMarketingStore((s) => s.selectedCampaignIds.length)
  const clearSelectedCampaigns = useMarketingStore((s) => s.clearSelectedCampaigns)

  if (count === 0) return null

  return (
    <span className="inline-flex items-center gap-1 rounded-full border border-primary/40 bg-primary/10 py-0.5 pl-3 pr-1 text-xs font-medium text-primary whitespace-nowrap">
      {count} selected
      <span aria-hidden="true" className="text-primary/50">·</span>
      <button
        type="button"
        onClick={clearSelectedCampaigns}
        aria-label="Clear campaign selection"
        className="inline-flex items-center gap-0.5 rounded-full px-1.5 py-0.5 hover:bg-primary/15 transition-colors"
      >
        Clear
        <X className="w-3 h-3" />
      </button>
    </span>
  )
}
